import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import AuthRoutes from "./auth.routes";
import OAuthRoutes from "./oauth.routes";
import AppRoutes from "./app.routes";
import PublicRoutes from "./public.routes";

const AppRouter = () => {
  return (
    <Suspense>
      <Routes>
        <Route
          path="/auth/*"
          element={<AuthRoutes />}
        />

        <Route
          path="/oauth/*"
          element={<OAuthRoutes />}
        />

        <Route
          path="/app/*"
          element={<AppRoutes />}
        />

        <Route
          path="/*"
          element={<PublicRoutes />}
        />

      </Routes>
    </Suspense>
  );
};

export default AppRouter;